var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Treeselect',_vm._g(_vm._b({attrs:{"multiple":""}},'Treeselect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }